import React, { useState, useRef, useEffect } from "react";
import "./EditVersionModal.css";
import { updateVersion } from "../../store/projectsSlice";
import { useDispatch } from "react-redux";

const EditVersionModal = ({
  onClose = () => {},
  onRenamed = () => {},
  fetchCurrentProjectById,
  version,
  currentProject,
  status,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [versionTitle, setVersionTitle] = useState(version?.version || "");
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    const keyDownHandler = (e) => {
      handleKeyDown(e);
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("keydown", keyDownHandler);
    };
  }, [onClose, versionTitle]);

  const handleSubmit = () => {
    setIsLoading(true);
    dispatch(
      updateVersion({
        versionId: version.versionId,
        title: versionTitle,
        // status,
      })
    )
      .then((res) => {
        setIsLoading(false);
        fetchCurrentProjectById();
        onRenamed(res.payload);
        onClose();
      })
      .catch(() => {
        setIsLoading(false);
      });
    setIsLoading(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    } else if (e.key === "Escape") {
      e.preventDefault();
      onClose();
    }
  };

  return (
    <div className="edit-version-modal-overlay">
      <div className="edit-version-modal" ref={modalRef}>
        <button className="edit-version-close-button" onClick={onClose} />
        <h1 className="edit-version-modal-title">Переименовать версию</h1>
        <div className="edit-version-modal-content">
          <input
            className="edit-version-title-input"
            placeholder="Название версии"
            value={versionTitle}
            onChange={(e) => setVersionTitle(e.target.value)}
          />
        </div>
        <button
          onClick={handleSubmit}
          className="edit-version-submit-button"
          disabled={isLoading}
        >
          {isLoading ? "Загрузка..." : "Сохранить"}
        </button>
      </div>
    </div>
  );
};

export default EditVersionModal;
